import React from 'react'
import Chart, { Props as ApexChartsProps } from 'react-apexcharts'
import { merge } from 'lodash'
import { defaultTypography, ptBr } from './types/index'
import { ChartColumnThemes, themes } from './types/ChartColumn'

type Props = {
  options: any
  series: number[]
  theme?: ChartColumnThemes
  height?: number
  type?: ApexChartsProps['type']
}

const ChartDonut = ({ options, series, theme = ChartColumnThemes.default, height = 440, type = 'donut' }: Props): JSX.Element => {
  const defaultOptions = {
    colors: themes[theme].seriesColors,
    chart: {
      type: 'donut',
      locales: [ptBr],
      defaultLocale: 'pt-br',
      ...defaultTypography
    },
    noData: {
      text: 'No data found :(',
      style: {
        fontSize: '12pt',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        color: '#4B4B4B',
        fontWeight: 400
      }
    }
  }
  return (
    <Chart options={merge(defaultOptions, options)} series={series} type={type} height={height} />
  )
}

export default ChartDonut
